export default __webpack_public_path__ + "static/Modular-393f684387ff9d2dbbe280ba7fdda291.jpg";